import React from 'react';
export var AmexCvvIconV2 = _ref => {
  var {
    ariaDescribedByContent,
    ariaDescribedById
  } = _ref;
  return React.createElement("svg", {
    fill: "none",
    height: "18",
    viewBox: "0 0 56 34",
    width: "29",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", {
    id: ariaDescribedById
  }, ariaDescribedByContent), React.createElement("g", {
    clipPath: "url(#clip0_15183_16185)"
  }, React.createElement("path", {
    d: "M0 2.89419C0 1.29577 1.28942 0 2.88 0H53.12C54.7106 0 56 1.29577 56 2.89419V31.1058C56 32.7042 54.7106 34 53.12 34H2.88C1.28942 34 0 32.7042 0 31.1058V2.89419Z",
    fill: "#003087"
  }), React.createElement("path", {
    d: "M6 10.2C6 9.0799 6 8.51984 6.21799 8.09202C6.40973 7.71569 6.71569 7.40973 7.09202 7.21799C7.51984 7 8.0799 7 9.2 7H14.8C15.9201 7 16.4802 7 16.908 7.21799C17.2843 7.40973 17.5903 7.71569 17.782 8.09202C18 8.51984 18 9.07989 18 10.2V10.5667C18 11.6868 18 12.2468 17.782 12.6746C17.5903 13.051 17.2843 13.3569 16.908 13.5487C16.4802 13.7667 15.9201 13.7667 14.8 13.7667H9.2C8.0799 13.7667 7.51984 13.7667 7.09202 13.5487C6.71569 13.3569 6.40973 13.051 6.21799 12.6746C6 12.2468 6 11.6868 6 10.5667V10.2Z",
    fill: "#56CCFE"
  }), React.createElement("path", {
    clipRule: "evenodd",
    d: "M49 17.96H39C38.4256 17.96 37.96 18.4256 37.96 19V25C37.96 25.5744 38.4256 26.04 39 26.04H49C49.5744 26.04 50.04 25.5744 50.04 25V19C50.04 18.4256 49.5744 17.96 49 17.96ZM39 17C37.8954 17 37 17.8954 37 19V25C37 26.1046 37.8954 27 39 27H49C50.1046 27 51 26.1046 51 25V19C51 17.8954 50.1046 17 49 17H39Z",
    fill: "#00CF92",
    fillRule: "evenodd"
  }), React.createElement("path", {
    d: "M40 21.5C40 21.2239 40.2239 21 40.5 21H41.5C41.7761 21 42 21.2239 42 21.5V22.5C42 22.7761 41.7761 23 41.5 23H40.5C40.2239 23 40 22.7761 40 22.5V21.5Z",
    fill: "#EDEDED"
  }), React.createElement("path", {
    d: "M6 21.5C6 21.2239 6.22386 21 6.5 21H7.5C7.77614 21 8 21.2239 8 21.5V22.5C8 22.7761 7.77614 23 7.5 23H6.5C6.22386 23 6 22.7761 6 22.5V21.5Z",
    fill: "#EDEDED"
  }), React.createElement("path", {
    d: "M16 21.5C16 21.2239 16.2239 21 16.5 21H17.5C17.7761 21 18 21.2239 18 21.5V22.5C18 22.7761 17.7761 23 17.5 23H16.5C16.2239 23 16 22.7761 16 22.5V21.5Z",
    fill: "#EDEDED"
  }), React.createElement("path", {
    d: "M26 21.5C26 21.2239 26.2239 21 26.5 21H27.5C27.7761 21 28 21.2239 28 21.5V22.5C28 22.7761 27.7761 23 27.5 23H26.5C26.2239 23 26 22.7761 26 22.5V21.5Z",
    fill: "#EDEDED"
  }), React.createElement("path", {
    d: "M43 21.5C43 21.2239 43.2239 21 43.5 21H44.5C44.7761 21 45 21.2239 45 21.5V22.5C45 22.7761 44.7761 23 44.5 23H43.5C43.2239 23 43 22.7761 43 22.5V21.5Z",
    fill: "#EDEDED"
  }), React.createElement("path", {
    d: "M9 21.5C9 21.2239 9.22386 21 9.5 21H10.5C10.7761 21 11 21.2239 11 21.5V22.5C11 22.7761 10.7761 23 10.5 23H9.5C9.22386 23 9 22.7761 9 22.5V21.5Z",
    fill: "#EDEDED"
  }), React.createElement("path", {
    d: "M19 21.5C19 21.2239 19.2239 21 19.5 21H20.5C20.7761 21 21 21.2239 21 21.5V22.5C21 22.7761 20.7761 23 20.5 23H19.5C19.2239 23 19 22.7761 19 22.5V21.5Z",
    fill: "#EDEDED"
  }), React.createElement("path", {
    d: "M29 21.5C29 21.2239 29.2239 21 29.5 21H30.5C30.7761 21 31 21.2239 31 21.5V22.5C31 22.7761 30.7761 23 30.5 23H29.5C29.2239 23 29 22.7761 29 22.5V21.5Z",
    fill: "#EDEDED"
  }), React.createElement("path", {
    d: "M46 21.5C46 21.2239 46.2239 21 46.5 21H47.5C47.7761 21 48 21.2239 48 21.5V22.5C48 22.7761 47.7761 23 47.5 23H46.5C46.2239 23 46 22.7761 46 22.5V21.5Z",
    fill: "#EDEDED"
  }), React.createElement("path", {
    d: "M12 21.5C12 21.2239 12.2239 21 12.5 21H13.5C13.7761 21 14 21.2239 14 21.5V22.5C14 22.7761 13.7761 23 13.5 23H12.5C12.2239 23 12 22.7761 12 22.5V21.5Z",
    fill: "#EDEDED"
  }), React.createElement("path", {
    d: "M22 21.5C22 21.2239 22.2239 21 22.5 21H23.5C23.7761 21 24 21.2239 24 21.5V22.5C24 22.7761 23.7761 23 23.5 23H22.5C22.2239 23 22 22.7761 22 22.5V21.5Z",
    fill: "#EDEDED"
  }), React.createElement("path", {
    d: "M32 21.5C32 21.2239 32.2239 21 32.5 21H33.5C33.7761 21 34 21.2239 34 21.5V22.5C34 22.7761 33.7761 23 33.5 23H32.5C32.2239 23 32 22.7761 32 22.5V21.5Z",
    fill: "#EDEDED"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_15183_16185"
  }, React.createElement("rect", {
    fill: "white",
    height: "34",
    width: "56"
  }))));
};